// extracted by mini-css-extract-plugin
export default {"container":"hero_container__GY525","root":"hero_root__5Wk-h","desktop":"hero_desktop__P9u73","about":"hero_about__Vu0ny","aboutP":"hero_aboutP__AMZ48"};